@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.mobileupdate

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.config.MobileUpdateConfigDto

object GetMobileUpdateConfigEndpoint : EndPoint<GetMobileUpdateConfigEndpoint.Request, GetMobileUpdateConfigEndpoint.Response>() {
    class Request()
    class Response(val config: MobileUpdateConfigDto)
}
